<template>
  <div class="table-wrapper">
    <table :class="tableClasses">
      <thead v-if="headers && headers.length">
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="index"
            :style="{ width: header.width, textAlign: header.align || 'left' }"
          >
            {{ header.text || header.title || header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>
    <div v-if="!$slots.default || empty" class="table-empty">
      <slot name="empty">
        {{ emptyText }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: '데이터가 없습니다'
    }
  },
  computed: {
    tableClasses() {
      return [
        'table',
        {
          'table--striped': this.striped,
          'table--bordered': this.bordered,
          'table--hoverable': this.hoverable,
          'table--compact': this.compact
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: $font-size-sm;

  th {
    padding: $spacing-3 $spacing-4;
    text-align: left;
    font-weight: $font-weight-semibold;
    color: $color-text-secondary;
    background-color: $table-header-bg;
    border-bottom: 1px solid $table-border-color;
    white-space: nowrap;
  }

  td {
    padding: $spacing-3 $spacing-4;
    border-bottom: 1px solid $table-border-color;
    color: $color-text-primary;
  }

  &--striped tbody tr:nth-child(even) {
    background-color: $color-gray-50;
  }

  &--bordered {
    th, td {
      border: 1px solid $table-border-color;
    }
  }

  &--hoverable tbody tr:hover {
    background-color: $table-row-hover-bg;
  }

  &--compact {
    th, td {
      padding: $spacing-2 $spacing-3;
    }
  }
}

.table-empty {
  padding: $spacing-12 $spacing-4;
  text-align: center;
  color: $color-text-tertiary;
  font-size: $font-size-sm;
}
</style>
